/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/licenseOperationsMappers";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a LicenseOperations. */
export class LicenseOperations {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a LicenseOperations.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Retrieves license for the user.
   * @summary Retrieves license for the user.
   * @param [options] The optional parameters
   * @returns Promise<Models.LicenseGetLicenseResponse>
   */
  getLicense(options?: coreHttp.RequestOptionsBase): Promise<Models.LicenseGetLicenseResponse>;
  /**
   * @param callback The callback
   */
  getLicense(callback: coreHttp.ServiceCallback<Models.License>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getLicense(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.License>): void;
  getLicense(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.License>, callback?: coreHttp.ServiceCallback<Models.License>): Promise<Models.LicenseGetLicenseResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getLicenseOperationSpec,
      callback) as Promise<Models.LicenseGetLicenseResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getLicenseOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/License",
  responses: {
    200: {
      bodyMapper: Mappers.License
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
